export default __webpack_public_path__ + "static/media/orderList.9d4a1be1.png";